/**
 * Shared configuration for error pages
 * Used by both React ErrorPage component and static HTML fallback
 */

const errorPageConfig = {
  title: "MusicMatrix",
  errorTitle: "Application Loading Error",
  errorMessage: "Sorry, we encountered a problem while loading the application. This may be due to your device or browser compatibility issues.",
  troubleshootingText: "Try these troubleshooting steps:",
  supportEmail: "lindasmart9977@gmail.com",
  supportText: "Contact Support",
  copyright: "Music Technology News & Insights",
  solutions: [
    {
      id: 'refresh',
      title: 'Refresh Page',
      description: 'Click your browser\'s refresh button or pull down to refresh',
      icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
      gradient: 'from-purple-500 to-indigo-500',
      cssGradient: 'linear-gradient(to bottom right, #8b5cf6, #6366f1)',
      action: 'refresh'
    },
    {
      id: 'clear-cache',
      title: 'Force Refresh',
      description: 'Bypass cache and reload the page (Windows: Ctrl+F5, Mac: ⌘+Shift+R)',
      icon: 'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
      gradient: 'from-blue-500 to-cyan-500',
      cssGradient: 'linear-gradient(to bottom right, #3b82f6, #06b6d4)'
    },
    {
      id: 'incognito',
      title: 'Use Incognito Mode',
      description: 'Try opening the site in incognito/private browsing mode',
      icon: 'M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z',
      gradient: 'from-teal-500 to-emerald-500',
      cssGradient: 'linear-gradient(to bottom right, #14b8a6, #10b981)'
    },
    {
      id: 'update-browser',
      title: 'Update Browser',
      description: 'Make sure your browser is updated to the latest version',
      icon: 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12',
      gradient: 'from-pink-500 to-rose-500',
      cssGradient: 'linear-gradient(to bottom right, #ec4899, #f43f5e)'
    },
    {
      id: 'alt-browser',
      title: 'Try Another Browser',
      description: 'Try accessing the site using Chrome, Firefox or other browsers',
      icon: 'M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      gradient: 'from-amber-500 to-orange-500',
      cssGradient: 'linear-gradient(to bottom right, #f59e0b, #f97316)'
    }
  ],
  // Error icon path
  errorIcon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
  // Email icon path
  emailIcon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
};

export default errorPageConfig; 